'use client';
import { factory, Box, Grid, Flex, Typography, Checkbox, omitText } from '@kohler-dsm-library/kohler-core';
import { CloseIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import classes from './StoreMenu.module.css.mjs';
import { ZipCodeInputField } from './ZipCodeInputField/ZipCodeInputField.mjs';

const StoreMenu = factory((props, ref) => {
  const { className, heading, CTAs, eyebrow, subheading, storeInfo, zipCodeInput, setStoreCTA, setMenuOpen, setIsOpenMobileMenu, ...rest } = props;
  const classNames = clsx(className, "kohler-store-menu-root", classes.storeMenu);
  return /* @__PURE__ */ React.createElement(Box, { component: "div", ref, className: classNames, ...rest }, /* @__PURE__ */ React.createElement(Grid, { className: clsx("center-grid", classes.storeMenuMainGrid) }, /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuMobileClose }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      onClick: () => {
        setMenuOpen?.(null);
        if (setIsOpenMobileMenu) {
          setIsOpenMobileMenu(false);
        }
      },
      className: classes.storeMenuMobileCloseIcon
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { withBoundingBox: false, size: "medium" })
  ), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-m",
      component: "button",
      type: "button",
      textColor: "var(--content-secondary)",
      className: classes.storeMenuMobileBackText,
      onClick: () => setMenuOpen?.(null)
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "small" }),
    " Menu"
  )), /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.storeMenuMainContent, !storeInfo && classes.storeMenuMainFullContent) }, /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuContentHeading }, eyebrow && /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-medium-m",
      textColor: "var(--content-primary)",
      component: isValidElement(eyebrow.text) ? "div" : eyebrow.component || "p"
    },
    eyebrow.text
  ), /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-title", textColor: "var(--content-primary)" }, heading.text), subheading && /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-m",
      textColor: "var(--content-primary)",
      component: isValidElement(subheading.text) ? "div" : subheading.component || "p"
    },
    subheading.text
  )), storeInfo && /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuContentInfoContainer }, /* @__PURE__ */ React.createElement(Typography, { className: classes.storeMenuContentInfo, size: "label-regular-m", component: "div" }, storeInfo), setStoreCTA && /* @__PURE__ */ React.createElement(Checkbox, { ...setStoreCTA }))), /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuZipContainer }, zipCodeInput.eyebrow && /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-medium-m",
      className: classes.storeMenuContentZipContainerEyebrow,
      component: isValidElement(zipCodeInput.eyebrow.text) ? "div" : zipCodeInput.eyebrow.component || "p"
    },
    zipCodeInput.eyebrow.text
  ), /* @__PURE__ */ React.createElement(ZipCodeInputField, { ...zipCodeInput }), CTAs && /* @__PURE__ */ React.createElement("ul", { className: classes.storeMenuContentList }, CTAs.map((CTA) => {
    return /* @__PURE__ */ React.createElement("li", { key: CTA.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: CTA.component || "a",
        ...omitText(CTA),
        className: clsx(classes.storeMenuContentListItemLink),
        size: "label-regular-m",
        style: { textDecoration: "underline" }
      },
      CTA.text
    ));
  })))));
});

export { StoreMenu };
